import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import {
  getVideoUrlIframe,
  isWhiteColor,
  removeDefaultParams,
} from '../../../Utils/helper';
import {
  cardServedEvent,
  fireClickedCta,
} from '../../../Utils/StoreHomePageUtils';
import { IframeVideo } from '../../GrowthTrackerPage/Inthisweek/styled';
import { GridBoxContent, GridBoxTitle } from '../BannersGrid/styled';
import { YoutubeVideoCTA, YoutubeVideoGrid } from './styled';

export default function StoreYTVideoSection(props) {
  let { data, stroller, homeVideo, catPage } = props;
  const player = useRef(null);

  useEffect(() => {
    cardServedEvent(data);
  }, []);

  const router = useRouter();
  const youtubeApiHandler = (url) => {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    tag.onload = onYouTubeIframeAPIReady;
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    function onYouTubeIframeAPIReady() {
      window.YT.ready(() => {
        player.current = new YT.Player('yt-player', {
          events: {
            onReady: onPlayerReady,
            onStateChange: onPlayerStateChange,
          },
        });
      });
    }

    function onPlayerReady(event) {
      event.target.playVideo();
    }

    function onPlayerStateChange(event) {
      if (event.data == 0 && typeof player.current.stopVideo === 'function') {
        player.current.stopVideo(); // for not showing related and Suggested vedios after vedio ends..
      }
      // -1 – unstarted
      // 0 – ended
      // 1 – playing
      // 2 – paused
      // 3 – buffering
      // 5 – video cued
    }
  };

  return (
    <YoutubeVideoGrid
      sectionBgColorEnd={data?.sectionBgColorEnd}
      sectionBgColorStart={data?.sectionBgColorStart}
      padding={
        !isWhiteColor(data?.sectionBgColorStart, data?.sectionBgColorEnd)
      }
      stroller={stroller}
      homeVideo={homeVideo}
      catPage={catPage}
    >
      <div>
        <IframeVideo
          onLoad={youtubeApiHandler}
          id={'yt-player'}
          storeVideo
          type="text/html"
          src={getVideoUrlIframe(data?.youtubeLink, 1, 1)}
          frameBorder="0"
          allowFullScreen
          allow={'autoplay'}
          stroller={stroller}
          homeVideo={homeVideo}
          catPage={catPage}
        ></IframeVideo>
      </div>
      <div>
        {data?.heading && <GridBoxTitle ytVideo>{data.heading}</GridBoxTitle>}

        {data?.subHeading && (
          <GridBoxContent ytVideo>{data.subHeading}</GridBoxContent>
        )}

        {data?.showCta ? (
          <Link
            href={{
              pathname: data?.deeplinkValue,
              query: removeDefaultParams(router.query),
            }}
            passHref
            locale={false}
            legacyBehavior
          >
            <YoutubeVideoCTA as="a" onClick={() => fireClickedCta(data)}>
              {data?.ctaText}
              <img src="/images/black_youtubearrow.svg" alt="" />
            </YoutubeVideoCTA>
          </Link>
        ) : null}
      </div>
    </YoutubeVideoGrid>
  );
}
